const CURRENCY_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Preserve a trailing decimal so users can type cents one character at a time. */
export const sanitizeCurrencyInput = (raw: string): string => {
  const [whole, ...fractions] = raw.replace(/[^\d.]/g, '').split('.');

  return fractions.length > 0 ? `${whole}.${fractions.join('')}` : whole;
};

/** Allows formatted values such as `$1,234.56` to round-trip on focus. */
export const parseCurrency = (raw: string): number => {
  const parsed = Number(sanitizeCurrencyInput(raw));

  return Number.isNaN(parsed) ? 0 : parsed;
};

export const formatCurrency = (value: number): string => CURRENCY_FORMATTER.format(value);
